module.exports = "/_next/static/images/b1cb8e6bb75e2d7ed5231e449d4b60a5-hero-large.jpg.webp";